import React from 'react';

import { PlayIcon as Icon } from '../../__icons';

// loading the sass style fot the component
import css from './styles.module.scss';

/**
 * Atom PlayIcon
 * 
 * a youtube play icon
 */
function PlayIcon (props) {

  const {
    className = "",
    size = 3,
    ...others
  } = props;

  return <Icon className={`${css["icon-play"]} ${className}`} data-size={size} {...others}/>;
}

export default PlayIcon;
